import type { ReactNode } from 'react';
import { cn } from '../../../components/ui/utils';
import type { HrTone } from './StatusPill';

const CHIP_CLASSES: Record<string, string> = {
  primary: 'bg-primary text-primary-foreground',
  warning: 'bg-warning text-primary-foreground',
  danger: 'bg-destructive text-destructive-foreground',
};

export interface HrKpiItem {
  label: string;
  value: ReactNode;
  unit?: string;
  detail?: ReactNode;
  tone?: HrTone | 'primary';
  icon?: ReactNode;
}

export function HrKpiGrid({ items }: { items: HrKpiItem[] }) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
      {items.map((item) => {
        const chip = CHIP_CLASSES[item.tone || 'primary'] || CHIP_CLASSES.primary;
        return (
          <div
            key={item.label}
            className="rounded-xl border border-border bg-card p-4 transition-shadow hover:shadow-md"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
                  {item.label}
                </p>
                <p className="mt-2 text-3xl font-semibold tracking-tight tabular-nums text-foreground">
                  {item.value}
                  {item.unit ? (
                    <span className="ml-1 text-sm font-medium text-muted-foreground">
                      {item.unit}
                    </span>
                  ) : null}
                </p>
                {item.detail ? (
                  <p className="mt-1 text-xs leading-relaxed text-muted-foreground">{item.detail}</p>
                ) : null}
              </div>
              {item.icon ? (
                <span
                  className={cn(
                    'grid h-9 w-9 shrink-0 place-items-center rounded-[10px]',
                    chip
                  )}
                  aria-hidden
                >
                  {item.icon}
                </span>
              ) : null}
            </div>
          </div>
        );
      })}
    </div>
  );
}
